"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5983],{

/***/ 66017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dU": function() { return /* binding */ isAdvancedVerificationIncomplete; },
  "z6": function() { return /* binding */ isResetTimePending; },
  "Ff": function() { return /* binding */ resolveExtremeGatePlatform; },
  "yI": function() { return /* binding */ shouldApplyIosExtremeBindGate; }
});

// UNUSED EXPORTS: IOS_EXTREME_FEATURE_PATHS, getBoundIcloudUsername, isAndroidPlatformMode, isBasicStepStillRequired, isBasicVerificationIncomplete, isBasicVerificationSatisfiedForOverlay, isIcloudBasicBound, isIosCloudMode, isIosExtremeFeaturePath, shouldForceBasicVerificationOverlay

;// CONCATENATED MODULE: ./src/utils/resolveCurrentDevicePlatformType.js
/**
 * 设备类型只信 user-device（allDeviceUser / 传入的 devices），
 * 不要用 user-account-order 的 platform_type。
 *
 * @param {Object} [options]
 * @param {Array} [options.devices] - getAllUserDevice 列表；缺省读 localStorage.allDeviceUser
 * @param {Object} [options.deviceUser] - 当前选中 DeviceUser；缺省读 localStorage
 * @param {string|number} [options.deviceId] - 指定设备 id（如订单 row.device_id）
 * @returns {string|null}
 */ const resolveCurrentDevicePlatformType = function() {
    let { devices , deviceUser , deviceId  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (false) {}
    let list = devices;
    if (!Array.isArray(list)) {
        try {
            list = JSON.parse(localStorage.getItem("allDeviceUser") || "[]");
        } catch (e) {
            list = [];
        }
    }
    if (!Array.isArray(list) || list.length === 0) {
        return localStorage.getItem("currentMode") || null;
    }
    let targetId = deviceId;
    let username = null;
    if (targetId == null || targetId === "") {
        let selected = deviceUser;
        if (!selected) {
            try {
                selected = JSON.parse(localStorage.getItem("DeviceUser") || "null");
            } catch (e1) {
                selected = null;
            }
        }
        var ref, ref1;
        targetId = (ref1 = (ref = selected === null || selected === void 0 ? void 0 : selected.device_id) !== null && ref !== void 0 ? ref : selected === null || selected === void 0 ? void 0 : selected.id) !== null && ref1 !== void 0 ? ref1 : null;
        var ref2, ref3;
        username = (ref3 = (ref2 = selected === null || selected === void 0 ? void 0 : selected.username) !== null && ref2 !== void 0 ? ref2 : selected === null || selected === void 0 ? void 0 : selected.iCloud_username) !== null && ref3 !== void 0 ? ref3 : null;
    }
    const matched = targetId != null && targetId !== "" && list.find((item)=>String(item.id) === String(targetId) || String(item.device_id) === String(targetId)) || username && list.find((item)=>String(item.iCloud_username || "").toLowerCase() === String(username).toLowerCase()) || null;
    return (matched === null || matched === void 0 ? void 0 : matched.platform_type) || localStorage.getItem("currentMode") || null;
};
/* harmony default export */ var utils_resolveCurrentDevicePlatformType = (resolveCurrentDevicePlatformType);

;// CONCATENATED MODULE: ./src/utils/iosIcloudBindStatus.js
/**
 * iCloud 基础/高级绑定状态（前端侧）
 * - Basic=1：基础绑定成功
 * - 高级绑定是否完成：看 resetTime.advancedDownloadTime
 *   （来自 /api/definition/user-device-reset-time 的 advanced_download_time，验证成功开始下载即写入）
 * - Updated 展示仍用 resetTime.advancedUpdateDownloadTime（USER_SUMMARY 下载完成时间）
 *
 * resetTime 字段约定：
 * - null：尚未拉取（刷新/首屏）→ 不得当成「未验证」去闪验证页
 * - ''：已拉取且确认未完成
 * - 时间字符串：已完成
 */ 
/** 侧栏 / Dashboard Extreme 功能路径 */ const IOS_EXTREME_FEATURE_PATHS = (/* unused pure expression or super */ null && ([
    "/text-messages",
    "/calls",
    "/voicemail",
    "/whatsapp",
    "/wa-business",
    "/line",
    "/kik",
    "/we-chat",
    "/messenger",
    "/browser-history",
    "/browser-bookmark",
    "/apps",
    "/wifi-networks",
    "/skype",
    "/teams",
    "/telegram",
    "/snapchat",
    "/instagram",
    "/facetime"
]));
function isIcloudBasicBound() {
    if (false) {}
    return String(window.localStorage.getItem("Basic")) === "1";
}
function getBoundIcloudUsername() {
    if (false) {}
    try {
        var ref;
        return ((ref = JSON.parse(window.localStorage.getItem("DeviceUser") || "{}")) === null || ref === void 0 ? void 0 : ref.username) || "";
    } catch (e) {
        return "";
    }
}
/** resetTime 是否仍在首屏拉取中（null = 未就绪） */ function isResetTimePending(resetTime) {
    if (!resetTime) return true;
    return resetTime.basicUpdateDownloadTime == null || resetTime.advancedDownloadTime == null;
}
/** 未完成基础验证（仅已拉取且为空时为 true；pending 时为 false） */ function isBasicVerificationIncomplete(resetTime) {
    if (isResetTimePending(resetTime)) return false;
    return resetTime.basicUpdateDownloadTime === "";
}
/**
 * （历史）功能页曾用 IosExtreme 遮罩判基础步骤；现功能页只出升级弹窗 / 跳转补充绑定页。
 * 仍可供其它入口复用：已 Basic=1 则不再强制基础验证。
 */ function shouldForceBasicVerificationOverlay(resetTime, basicVerfiyOver) {
    if (isIcloudBasicBound()) return false;
    if ([
        true,
        "true"
    ].includes(basicVerfiyOver)) return false;
    return isBasicVerificationIncomplete(resetTime);
}
/** 基础已满足：Basic=1 / redux 已过 / 下载完成时间已有 */ function isBasicVerificationSatisfiedForOverlay(resetTime, basicVerfiyOver) {
    return !shouldForceBasicVerificationOverlay(resetTime, basicVerfiyOver);
}
/**
 * 是否仍缺「基础」步骤（已 Basic=1 则否）。
 * 功能页门控已改为 useExtremeFeatureAccessGate；此函数仍用于 ios-verfiy-process 等。
 */ function isBasicStepStillRequired(resetTime) {
    if (isIcloudBasicBound()) return false;
    return isBasicVerificationIncomplete(resetTime);
}
/**
 * 未完成高级绑定。
 * @param {object|string|null|undefined} resetTimeOrValue
 *   - 传 resetTime 对象：读 advancedDownloadTime
 *   - 传字符串：兼容直接传时间值
 * pending（null）时返回 false，避免刷新闪验证/误跳转
 */ function isAdvancedVerificationIncomplete(resetTimeOrValue) {
    if (resetTimeOrValue != null && typeof resetTimeOrValue === "object") {
        if (isResetTimePending(resetTimeOrValue)) return false;
        return resetTimeOrValue.advancedDownloadTime === "";
    }
    if (resetTimeOrValue == null) return false;
    return resetTimeOrValue === "";
}
function isIosExtremeFeaturePath(path) {
    if (!path) return false;
    return IOS_EXTREME_FEATURE_PATHS.includes(path);
}
/**
 * 解析用于 Extreme 门控的平台：优先 user-device.platform_type，再 currentMode。
 * @param {string} [mode]
 * @returns {string}
 */ function resolveExtremeGatePlatform(mode) {
    const fromDevice =  true ? utils_resolveCurrentDevicePlatformType() : 0;
    return fromDevice || mode || ( true ? window.localStorage.getItem("currentMode") : 0) || "";
}
/** 是否 Android 平台（无 iCloud 基础/高级绑定概念） */ function isAndroidPlatformMode(mode) {
    return String(resolveExtremeGatePlatform(mode)).startsWith("Android");
}
/** 是否 iOS-Cloud（唯一有基础/高级绑定的平台） */ function isIosCloudMode(mode) {
    return resolveExtremeGatePlatform(mode) === "iOS-Cloud";
}
/** 是否启用 iOS 高级绑定门控（非 iOS-Cloud 恒为 false） */ function shouldApplyIosExtremeBindGate(mode) {
    if (true) {
        var ref;
        const path = ((ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || "";
        if (path.startsWith("/android")) return false;
    }
    if (isAndroidPlatformMode(mode)) return false;
    return isIosCloudMode(mode);
}


/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "cw": function() { return /* binding */ isGraceDevice; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定由 userEntryGate 负责（后端状态优先），这里不参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ })

}]);